<template>
  <v-dialog v-model="dialog" max-width="800">
    <v-card>
      <v-toolbar color="success" dark flat>
        <v-toolbar-title>{{ $t('esgPlatform.editSurvey') }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pt-6">
        <div class="text-body-1 mb-4">
          <p>
            {{ $t('esgPlatform.editSurveyWarning') }}
          </p>
          <p>
            <br />
            <a href="#" @click.prevent="createSurveyCopy" class="text--primary font-weight-medium">
              {{ $t('esgPlatform.clickToCreateCopy') }}
            </a>
          </p>
        </div>
      </v-card-text>
      <v-card-actions class="px-5 pb-5">
        <v-spacer></v-spacer>
        <v-btn outlined color="success" @click="close">
          {{ $t('esgPlatform.cancel') }}
        </v-btn>
        <v-btn color="success" dark @click="proceedEdit">
          {{ $t('esgPlatform.continueAndEdit') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "EditSurveyWarning",
  props: {
    dialog: {
      type: Boolean,
      required: true
    },
    surveyId: {
      type: String,
      required: true
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    proceedEdit() {
      this.$emit("proceed");
    },
    createSurveyCopy() {
      this.$emit("copy");
    }
  }
};
</script>

<style scoped>
/* .text-body-1 {
  line-height: 1.6;
} */
</style>